// A person's initials, with their full name as a tooltip.
export const initialsRender = (firstName: string | null | undefined, lastName: string | null | undefined) => {
    const first = firstName?.trim() ?? '';
    const last = lastName?.trim() ?? '';

    return (
        <span
            title={`${first} ${last}`.trim()}
            style={{ cursor: 'pointer' }}
        >
            {`${first.substring(0, 1)}${last.substring(0, 1)}`.toUpperCase()}
        </span>
    );
};
